import { render, staticRenderFns } from "./bo-image-lightbox.vue?vue&type=template&id=5374cfa4"
import script from "./bo-image-lightbox.vue?vue&type=script&lang=js"
export * from "./bo-image-lightbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports